import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "my-3 mx-4" }
const _hoisted_3 = { class: "d-flex justify-center py-2 bg-blue-lighten-1" }

import {ref} from "vue";
import {ApiMap} from "@/api/type";
import {useApi} from "@/api/handler";
import {team} from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamList',
  setup(__props, { expose: __expose }) {

const teamList = ref<ApiMap['/team/game/:id']['resp'] | null>(null)
const pageSize = ref<number>(100)
const headers = [
  { title: '组号', key: 'teamId', align: 'center' },
  { title: '组长姓名', key: 'leaderName', align: 'center' },
  { title: '组长学号', key: 'leaderSno', align: 'center' },
  { title: '组长ID', key: 'leaderId', align: 'begin' },
  { title: '组员数量', key: 'totalMembers', align: 'begin'},
]

const subheaders = [
  { title: '学生ID', key: 'studentId', align: 'center' },
  { title: '学生姓名', key: 'studentName', align: 'center' },
  {title: '学号', key: 'studentSno', align: 'center' },
  {title: '是否组长', key: 'isLeader', align: 'begin' },
]

const useTeamList = (gameId: number) => {
  useApi({
    api: team.TeamList(gameId),
    onSuccess: resp => {
      teamList.value = resp.data as ApiMap['/team/game/:id']['resp']
    }
  })
}

__expose({useTeamList})

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "w-100 my-4 mx-10",
    height: 700,
    style: {"overflow-y":"auto"}
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "px-10 py-4 bg-indigo-lighten-2 text-lg-h6" }, "分组情况", -1)),
      _createVNode(_component_v_data_table, {
        items: teamList.value ? teamList.value.teams : [],
        headers: headers,
        "item-value": "teamId",
        "show-expand": "",
        "hide-default-footer": "",
        "items-per-page": pageSize.value,
        "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((pageSize).value = $event)),
        "no-data-text": "请先提交游戏设置"
      }, {
        "expanded-row": _withCtx(({ columns, item }) => [
          _createElementVNode("tr", null, [
            _createElementVNode("td", {
              colspan: columns.length,
              class: "bg-grey-lighten-4"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, "第" + _toDisplayString(item.teamId) + "组", 1),
                _createVNode(_component_v_data_table, {
                  items: item.members,
                  "hide-default-footer": "",
                  headers: subheaders
                }, {
                  "item.isLeader": _withCtx(({ value }) => [
                    _createVNode(_component_v_chip, {
                      density: "compact",
                      color: value ? 'green' : 'red'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(value ? '是' : '否'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 2
                }, 1032, ["items"])
              ])
            ], 8, _hoisted_1)
          ])
        ]),
        _: 1
      }, 8, ["items", "items-per-page"])
    ]),
    _: 1,
    __: [1]
  }))
}
}

})